import { put, call, takeLatest } from 'redux-saga/effects'
import { INIT_KEYCLOAK, SET_KEYCLOAK, LOG_OUT, SET_CONTEXT } from '../actions/type'
import { logoutByUser, getContextInfo, setCookie, } from '../../helpers';
import Keycloak from "keycloak-js";
import { isEmpty } from 'lodash';


async function onKeycloak() {
    // const keycloak = Keycloak(process.env.PUBLIC_URL+"/keycloak.json");
    const keycloak = Keycloak({ clientId: window._env_.clientid, realm: window._env_.realm, url: window._env_.keycloak_url })
    console.log("onKeycloak", keycloak)
    await keycloak
        .init({
            onLoad: "check-sso",
            checkLoginIframe: false,
            silentCheckSsoRedirectUri:
                window.location.origin + "/" + process.env.PUBLIC_URL + "/silent-check-sso.html",
        })
    return keycloak
}

function* initKeycloak() {
    const keycloak = yield call(onKeycloak)
    yield put({
        type: SET_KEYCLOAK,
        payload: {
            keycloak,
            authenticated: keycloak.authenticated
        }
    })

    let { refreshToken, authenticated } = keycloak
    setCookie('keycloak', JSON.stringify({ refreshToken, authenticated }))

    if (!isEmpty(keycloak) && keycloak.authenticated) {
        let context = yield call(getContextInfo, keycloak)
        if (!isEmpty(context)) {
            let { avatar, email, name, p, pkgcode } = context
            yield put({
                type: SET_CONTEXT,
                payload: {
                    avatar, email, name, p, pkgcode
                }
            })
        }
    }
}

function* bypassLogout({ payload }) {
    const { path } = payload
    const keycloak = yield call(onKeycloak)
    yield put({
        type: SET_KEYCLOAK,
        payload: {
            keycloak: keycloak
        }
    })
    if (keycloak.authenticated) {
        yield call(logoutByUser, keycloak)
    } else {
        window.location.href = path
        // yield call(router.history.push, path)
    }
}

function* authentication() {
    yield takeLatest(INIT_KEYCLOAK, initKeycloak)
    yield takeLatest(LOG_OUT, bypassLogout)
}

export default authentication